module.exports = __webpack_public_path__ + "img/icon_home_lianghua@2x.241f43f3.png";